<template>
  <el-dialog
      :visible.sync="dialogVisible"
      class="root"
      width="750px">
    <div slot="title" class="title">
      {{ title }}
    </div>
    <template v-if="!showTable">
      <template slot="footer">
        <el-button type="primary" icon="el-icon-s-platform" @click="upsert">
          儲存
        </el-button>
      </template>
      <el-form label-width="120px" :model="temperature" :rules="rules" ref="ruleForm">
        <el-form-item label="員工" prop="employee">
          <div class="flex">
            <template v-if="temperature.employee">
              <span class="emp_str">{{ employeeStr }}</span>
            </template>
            <el-button type="primary" v-if="type === 'add' && !showTable" @click="showTable = true">
              選擇員工
            </el-button>
          </div>
        </el-form-item>
        <el-form-item label="其他症狀" prop="has_symptom">
          <el-switch
              class="pl-4"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :value="symptom"
              @change="temperature.has_symptom = $event"
              active-text="有"
              inactive-text="無">
          </el-switch>
        </el-form-item>
        <el-form-item label="已就醫" prop="has_go_hospital">
          <el-switch
              class="pl-4"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :value="goHospital"
              @change="temperature.has_go_hospital = $event"
              active-text="是"
              inactive-text="否">
          </el-switch>
        </el-form-item>
        <el-form-item label="COVID-19 相關" prop="is_covid_related">
          <el-switch
              class="pl-4"
              active-color="#13ce66"
              inactive-color="#ff4949"
              :value="covidRelated"
              @change="temperature.is_covid_related = $event"
              active-text="是"
              inactive-text="否">
          </el-switch>
        </el-form-item>
        <el-form-item label="體溫" prop="value">
          <el-slider
              class="pl-4"
              v-model="temperature.value"
              :step="0.1"
              :marks="marks"
              :min="30"
              :max="45"
              show-input>
          </el-slider>
        </el-form-item>
      </el-form>
    </template>
    <ezoom-table v-if="type === 'add' && showTable" :search="search" :data="employees" :columns="columns">
      <template slot="buttons">
        <el-input
            style="margin-left: 20px;width: 200px"
            v-model="search"
            size="mini"
            placeholder="搜尋"/>
      </template>
      <el-table-column
          fixed="left"
          label="操作"
          width="120">
        <template slot-scope="scope">
          <el-button @click.stop="select(scope.row)" type="success" size="small">選擇</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="department" sortable label="部門" width="200"/>
      <el-table-column prop="employeeId" sortable label="員工編號" width="200"/>
      <el-table-column prop="employeeName" sortable label="姓名"/>
    </ezoom-table>
  </el-dialog>
</template>

<script>
import {ref, computed} from "@vue/composition-api";
import EzoomTable from '@/components/EzoomTable.vue';

export default {
  name: "CrudTemperature",
  props: {
    employees: Array,
    addFn: Function,
    updateFn: Function,
  },
  components: {
    EzoomTable
  },
  setup() {

    const type = ref('');
    const employee = ref({});
    const dialogVisible = ref(false);
    const temperature = ref({
      employee: null,
      value: 37.0,
      has_symptom: null,
      is_covid_related: null,
      has_go_hospital: null,
      symptom_text: null,
    });

    const openDialog = (row, newType) => {

      if (newType === 'update') {

        employee.value = {
          id: row.employee_id,
          name: row.employee_name,
          department: row.department
        };

        temperature.value = {
          ...row,
          value: parseFloat(row.value),
          employee: employee.value
        };

      } else if (newType === 'add') {

        employee.value = {};
        temperature.value = {
          employee: {},
          value: 37.0,
          has_symptom: null,
          has_go_hospital: null,
          is_covid_related: null,
        };
      }

      type.value = newType;
      dialogVisible.value = true;
    };

    const search = ref('');
    const showTable = ref(false);
    const columns = ref([
      {label: "員工編號", prop: "employeeId"},
      {label: "姓名", prop: "employeeName"},
      {label: "部門", prop: "department"},
    ]);

    const rules = ref({
      employee: [
        {required: true, message: '員工為必填欄位', trigger: 'change'},
      ],
      value: [
        {required: true, message: "體溫為必填欄位", trigger: "change"}
      ],
    });

    const symptom = computed(() => Boolean(temperature.value.has_symptom));
    const covidRelated = computed(() => Boolean(temperature.value.is_covid_related));
    const goHospital = computed(() => Boolean(temperature.value.has_go_hospital));

    const title = computed(() => {

      if (showTable.value) return '選擇員工';
      else if (type.value === 'add') return '新增體溫回報紀錄';
      else if (type.value === 'update') return '修改體溫回報紀錄';
      else return '';
    });

    const employeeStr = computed(() => {

      const emp = temperature.value.employee;
      return emp.id ? `${emp.name}(${emp.department} - ${emp.id})` : '';
    });

    return {
      openDialog,
      search,
      rules,
      title,
      showTable,
      dialogVisible,
      columns,
      type,
      employeeStr,
      employee,
      temperature,
      symptom,
      covidRelated,
      goHospital,
    };
  },
  methods: {
    select(row) {

      this.showTable = false;
      this.temperature.employee = {
        ...row,
        name: row.employeeName,
        department: row.department,
        id: row.employeeId
      }
    },
    getData() {

      return {
        value: this.temperature.value,
        has_symptom: this.symptom,
        is_covid_related: this.covidRelated,
        has_go_hospital: this.goHospital,
        line_id: this.temperature.employee.lineId,
        employee_id: this.temperature.employee.employeeId,
        id: this.temperature.id,
      }
    },
    upsert() {

      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.type === 'add' ? this.addFn(this.getData()).then(() => this.dialogVisible = false) : this.updateFn(this.getData()).then(() => this.dialogVisible = false)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
  },
  computed: {
    marks() {

      return {
        35: '35°C',
        37.5: {
          style: {
            color: '#fa1930',
          },
          label: <strong>37.5°C</strong>
        },
        40: '40°C',
      }
    },
  }
}
</script>

<style scoped>

.emp_str {
  padding-left: 10px;
  padding-right: 10px;
  font-size: 30px;
}

.root {
  text-align: left;
  font-weight: 900;
}

.title {
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-weight: bolder;
  margin-right: 30px;
}
</style>
